import type { Theme } from "../tokens";

/** A zine run off on a Risograph. Two inks, because two inks is what the machine has. */
export const riso: Theme = {
  id: "riso",
  name: "Riso",
  thesis: "A zine run off on a Risograph. Two inks, because two inks is what the machine has.",
  scheme: "light",
  colors: {
    ground: "#F0EBDC",
    surface: "#F7F4E9",
    raised: "#EFEADB",
    ink: "#1F1B16",
    dim: "#6B6455",
    rule: "#D6CDB7",
    lattice: "#E4DCC8",
    focus: "#0050B4",
    inbox: "#A32270",
    feed: "#0050B4",
    paperTrail: "#6B6455",
    screener: "#1F1B16",
  },
  type: {
    sans: "'Bitter', Georgia, serif",
    mono: "'Space Mono', ui-monospace, monospace",
    googleFonts: "Bitter:wght@400;600;700&family=Space+Mono:wght@400",
    tracking: "0",
  },
  density: {
    row: 46,
    primary: 15,
    secondary: 14,
    meta: 12,
    listWidth: 740,
    rail: 204,
    radius: 0,
    lineHeight: 1.45,
  },
  markers: {
    inbox: "●",
    feed: "◆",
    paperTrail: "▭",
    screener: "▲",
  },
  extraCss: "background-image:radial-gradient(#1F1B16 0.8px,transparent 0.9px);background-size:3px 3px;",
};
